import React from "react";
import {css, Theme} from "@emotion/react";

import {mb, pb, pt} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {HorizontalArticleList} from "../../../article/components/HorizontalArticleList";
import {IVendorDetailArticle} from "../../actions/fetch_vendor_detail_related_articles";
import {VendorContainer} from "../VendorContainer";

interface IProps {
    vendorName: string;
    articles: IVendorDetailArticle[];
}

export const VendorDetailArticles = (props: IProps) => {
    return (
        <div css={articlesHolder}>
            <VendorContainer>
                <Text as="h2" variant="headline_4" css={headingStyles}>
                    {props.vendorName} - wiadomości
                </Text>

                <HorizontalArticleList articles={props.articles} />
            </VendorContainer>
        </div>
    );
};

const articlesHolder = (theme: Theme) => css`
    background-color: ${theme.colors.background["200"]};
    ${pt(3)};
    ${pb(4)};

    @media (min-width: ${theme.breakpoints.md}) {
        ${pt(4)};
        ${pb(7)};
    }
`;

const headingStyles = css`
    ${mb(4)};
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {mb, pb, pt} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {HorizontalArticleList} from "../../../article/components/HorizontalArticleList";
import {IVendorDetailArticle} from "../../actions/fetch_vendor_detail_related_articles";
import {VendorContainer} from "../VendorContainer";

interface IProps {
    vendorName: string;
    articles: IVendorDetailArticle[];
}

export const VendorDetailArticles = (props: IProps) => {
    return (
        <div css={articlesHolder}>
            <VendorContainer>
                <Text as="h2" variant="headline_4" css={headingStyles}>
                    {props.vendorName} - wiadomości
                </Text>

                <HorizontalArticleList articles={props.articles} />
            </VendorContainer>
        </div>
    );
};

const articlesHolder = (theme: Theme) => css`
    background-color: ${theme.colors.background["200"]};
    ${pt(3)};
    ${pb(4)};

    @media (min-width: ${theme.breakpoints.md}) {
        ${pt(4)};
        ${pb(7)};
    }
`;

const headingStyles = css`
    ${mb(4)};
`;
